if (!customElements.get('wish-list-notification')) {
  customElements.define('wish-list-notification', class WishListNotification extends ModalDialog {
    show() {
      this.resetState();
      this.style.display = 'block';

      setTimeout(() => {
        this.hide()
      }, 3000);
    }

    /**
     * @param info
     */
    modifyContent(info) {
      this.modalContent = this.querySelector('[class^="WishListNotificationContent-"]');

      if(info.color){
        const colorElement = this.modalContent.querySelector('[data-color]');
        colorElement.textContent = info.color;
      }
      
      if(info.size){
        const sizeElement = this.modalContent.querySelector('[data-size]');
        sizeElement.textContent = info.size;
      }

      if (info.image) {
        this.modalContent.querySelector('[data-image]').src = info.image;
      }
    }

    resetState() {
      document.querySelectorAll('wish-list-notification').forEach((notification) => {
        notification.style.display = 'none';
      })
    }

    hide() {
      this.style.display = 'none';
    }
  })
}